// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"de37d003","294":"eb4a2a60","368":"8d16be35","640":"23a26201","718":"0d65c4d7","777":"03206b02","839":"51f923dc","895":"97a92a71"}[chunkId] + ".css";
};